import { IOption } from "@erelego/design-system/components/atoms/DropdownSelect/component/OptionItem";
import { ICheckBoxData } from "@erelego/design-system/components/molecules/MultiSelectDropdown/components/CheckBoxsContainer";
import { IFieldsMap } from "@common/redux/formBuilder/interface";
import {
  FieldProps,
  FormFieldTypes,
} from "@presentation/FormBuilder/components/FormFieldSelector/interfaces";

import {
  IFieldLevelRuleActionServer,
  IFieldLevelRuleConditionMap,
} from "@common/redux/forms/interface";

import { IFieldLevelRuleClient } from "../interface";
import {
  IFieldLevelRuleServer,
  IFormLevelRuleClient,
  IPageLevelRuleClient,
  IPageLevelRuleConditionMap,
} from "./interface";
import { IAttribute } from "@common/redux/admin/interface";

export const cleanOrgKey = (key: string) => {
  if (key.startsWith("org")) {
    const underscoreIndex = key.indexOf("_");
    if (underscoreIndex !== -1) {
      return key.substring(underscoreIndex + 1);
    }
  }
  return key;
};
export const getFilteredFieldsnameAndIdSelector = (
  fieldsMap: IFieldsMap,
  fieldIdsIgnore: string[],
  fieldTypesToIgnore: string[]
): IOption[] => {
  const filteredFieldOptions: any = [];
  Object.keys(fieldsMap).map((key: string) => {
    const fieldData: FieldProps = fieldsMap[key];
    const {
      title = "",
      name = "",
      localId,
      isSection,
      fieldType = "",
      parentFormId,
    } = fieldData;
    const checkIsSection =
      isSection || fieldType == FormFieldTypes?.SECTION || false;
    if (
      !fieldIdsIgnore.includes(key) &&
      !checkIsSection &&
      !fieldTypesToIgnore.includes(fieldType)
    ) {
      filteredFieldOptions.push({
        content: name || title || "Untitled field",
        value: key,
        fieldType,
        parentFormId,
        localId,
        title,
        // subtitle: fieldType || "",//can be used for better UX
      });
    }
  });
  return filteredFieldOptions;
};
export const getFilteredFieldsnameAndIdSelectorForAction = (
  fieldsMap: IFieldsMap,
  fieldIdsIgnore: string[],
  fieldTypesToIgnore: string[]
): ICheckBoxData[] => {
  const filteredFieldOptions: any = [];
  Object.keys(fieldsMap).map((key: string) => {
    const fieldData: FieldProps = fieldsMap[key];

    const {
      title = "",
      localId,
      fieldType = "",
      parentFormId,
      name = "",
    } = fieldData;

    // const checkIsSection = isSection || fieldType == FormFieldTypes?.SECTION || false;
    if (
      !fieldIdsIgnore.includes(key) &&
      // !checkIsSection &&
      !fieldTypesToIgnore.includes(fieldType)
    ) {
      filteredFieldOptions.push({
        content: name || title || "Untitled field",
        value: key,
        fieldType,
        parentFormId,
        localId,
        title: name || title || "Untitled field",
        // subtitle: fieldType || "",//can be used for better UX
      });
    }
  });
  return filteredFieldOptions;
};
export const emptyCondition = {
  operator: "",
  value: "",
  fieldType: "",
  fieldLocalId: "",
};
export const emptyActions = {
  fieldType: "",
  fieldLocalId: "",
  subFormLocalId: "",
  visiblity: "SHOW",
};
export const showHideFieldOptions = [
  {
    content: "Show",
    value: "SHOW",
  },
  {
    content: "Hide",
    value: "HIDE",
  },
];

export const fieldConstraint = (fieldType: string): IOption[] => {
  const constraint: any = constraintConfigs[fieldType] || {};
  const inputConstraint = Object.keys(constraint).map((key: string) => ({
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    content: allConstraintNames[key],
    value: key,
  }));
  return inputConstraint;
};
export const ignoredFieldType = [
  FormFieldTypes.FILE_UPLOAD,
  FormFieldTypes.CHECK_BOX,
  FormFieldTypes.DATE_TIME_PICKER,
  FormFieldTypes.PAYMENT,
  FormFieldTypes.NUMBER_INPUT,
  FormFieldTypes.CALCULATIVE,
  FormFieldTypes.BLANK_BOX,
  // FormFieldTypes.DATA_GRID,
  FormFieldTypes.PAYMENT,
  // FormFieldTypes.GEOLOCATION,
];

export const ignoredFieldTypeForInfographics = [
  FormFieldTypes.FILE_UPLOAD,
  FormFieldTypes.SECTION,
  FormFieldTypes.DESCRIPTION,
  FormFieldTypes.PAGE_BREAK,
  FormFieldTypes.DECIMAL,
  FormFieldTypes.BLANK_BOX,
  FormFieldTypes.BANNER,
  // FormFieldTypes.DATA_GRID,
];

export const ignoredFieldConditionType = [
  FormFieldTypes.FILE_UPLOAD,
  FormFieldTypes.BLANK_BOX,
  // FormFieldTypes.DATA_GRID,
  FormFieldTypes.DESCRIPTION,
  FormFieldTypes.PAGE_BREAK,
  FormFieldTypes.SECTION,
  FormFieldTypes.BANNER,
];
export const ignoredFieldActionType = [FormFieldTypes.BLANK_BOX];

export const ignoredBarChartInfographicFieldType = [
  FormFieldTypes.FILE_UPLOAD,
  FormFieldTypes.TEXT_AREA,
  // FormFieldTypes.SECTION,
  FormFieldTypes.PAYMENT, //CONFIG NOT ADDED IN BE
  // FormFieldTypes.GEOLOCATION,//CONFIG NOT ADDED IN BE
];

export const ignoredPieInfographicFieldType = [
  FormFieldTypes.TEXT_AREA,
  FormFieldTypes.PAYMENT,
  FormFieldTypes.DATE_INPUT,
  FormFieldTypes.TIME_PICKER,
  FormFieldTypes.DATE_TIME_PICKER,
  FormFieldTypes.FILE_UPLOAD,
  // FormFieldTypes.GEOLOCATION,//CONFIG NOT ADDED IN BE
];
export const ignoredInfographicFieldType = [
  FormFieldTypes.TEXT_AREA,
  FormFieldTypes.PAYMENT,
  FormFieldTypes.FILE_UPLOAD,
  // FormFieldTypes.GEOLOCATION,//CONFIG NOT ADDED IN BE
];
export const infographicAggregationField = [
  FormFieldTypes.TEXT_INPUT,
  FormFieldTypes.DROPDOWN,
  FormFieldTypes.MULTIPLE_CHOICES,
  FormFieldTypes.TEXT_AREA,
  FormFieldTypes.DATE_INPUT,
  FormFieldTypes.TIME_PICKER,
  FormFieldTypes.LINEAR_SCALING,
  FormFieldTypes.FILE_UPLOAD,
  FormFieldTypes.RATING,
  FormFieldTypes.DATE_TIME_PICKER,
  FormFieldTypes.CHECK_BOX,
  FormFieldTypes.DECIMAL,
  FormFieldTypes.DECISION_BOX,
  FormFieldTypes.PAGE_BREAK,
  FormFieldTypes.PAYMENT,
  FormFieldTypes.SECTION,
  FormFieldTypes.BANNER,
  // FormFieldTypes.GEOLOCATION,//CONFIG NOT ADDED IN BE
];
export const ignoredInfographicFieldSummary = [
  FormFieldTypes.TEXT_INPUT,
  FormFieldTypes.TEXT_AREA,
  FormFieldTypes.FILE_UPLOAD,
  FormFieldTypes.DECIMAL,
  FormFieldTypes.PAGE_BREAK,
  FormFieldTypes.SECTION,
  FormFieldTypes.DESCRIPTION,
  FormFieldTypes.BLANK_BOX,
  FormFieldTypes.BANNER,
  // FormFieldTypes.DATA_GRID,
  // FormFieldTypes.GEOLOCATION,//CONFIG NOT ADDED IN BE
  // FormFieldTypes.DATE_INPUT,
  // FormFieldTypes.TIME_PICKER,
  // FormFieldTypes.LINEAR_SCALING,
  // FormFieldTypes.CURRENCY,
  // FormFieldTypes.RATING,
  // FormFieldTypes.DATE_TIME_PICKER,
  // FormFieldTypes.CHECK_BOX,
  // FormFieldTypes.NUMBER_INPUT,
  // FormFieldTypes.DECISION_BOX,
  // FormFieldTypes.CALCULATIVE,
  // FormFieldTypes.PAYMENT,
];

export const constraintWithRequiredValue = [
  "IS",
  "IS_NOT",
  "CONTAINS",
  "NOT_CONTAINS",
  "STARTS_WITH",
  "ENDS_WITH",
  "MAXIMUM_TEXT_LENGTH",
  "LESS_THAN",
  "GREATER_THAN",
  "LESS_THAN_OR_EQUALS_TO",
  "GREATER_THAN_OR_EQUALS_TO",
  "MAXIMUM_DIGIT_LENGTH",
];
const commonFieldConstraint = {
  IS: "IS",
  IS_NOT: "IS_NOT",
  IS_EMPTY: "IS_EMPTY",
  IS_NOT_EMPTY: "IS_NOT_EMPTY",
};

export const constraintConfigs: any = {
  TEXT_INPUT: {
    ...commonFieldConstraint,
    CONTAINS: "CONTAINS",
    NOT_CONTAINS: "NOT_CONTAINS",
    STARTS_WITH: "STARTS_WITH",
    ENDS_WITH: "ENDS_WITH",
    // MAXIMUM_TEXT_LENGTH :"MAXIMUM_TEXT_LENGTH",
  },
  SEQUENCE: {
    ...commonFieldConstraint,
    CONTAINS: "CONTAINS",
    NOT_CONTAINS: "NOT_CONTAINS",
    STARTS_WITH: "STARTS_WITH",
    ENDS_WITH: "ENDS_WITH",
    // MAXIMUM_TEXT_LENGTH :"MAXIMUM_TEXT_LENGTH",
  },
  LOOKUP: {
    IS: "IS",
    IS_NOT: "IS_NOT",
    CONTAINS: "CONTAINS",
    NOT_CONTAINS: "NOT_CONTAINS",
    // MAXIMUM_TEXT_LENGTH :"MAXIMUM_TEXT_LENGTH",
  },
  TEXT_AREA: {
    ...commonFieldConstraint,
    CONTAINS: "CONTAINS",
    NOT_CONTAINS: "NOT_CONTAINS",
    STARTS_WITH: "STARTS_WITH",
    ENDS_WITH: "ENDS_WITH",
    // MAXIMUM_TEXT_LENGTH :"MAXIMUM_TEXT_LENGTH",
  },
  CURRENCY: {
    ...commonFieldConstraint,
    LESS_THAN: "LESS_THAN",
    GREATER_THAN: "GREATER_THAN",
    LESS_THAN_OR_EQUALS_TO: "LESS_THAN_OR_EQUALS_TO",
    GREATER_THAN_OR_EQUALS_TO: "GREATER_THAN_OR_EQUALS_TO",
    // BETWEEN: "BETWEEN",
    // MAXIMUM_DIGIT_LENGTH = "MAXIMUM_DIGIT_LENGTH",
  },
  RATING: {
    ...commonFieldConstraint,
    LESS_THAN: "LESS_THAN",
    GREATER_THAN: "GREATER_THAN",
    LESS_THAN_OR_EQUALS_TO: "LESS_THAN_OR_EQUALS_TO",
    GREATER_THAN_OR_EQUALS_TO: "GREATER_THAN_OR_EQUALS_TO",
    // BETWEEN: "BETWEEN",
    // MAXIMUM_DIGIT_LENGTH = "MAXIMUM_DIGIT_LENGTH",
  },
  DATE_INPUT: {
    ...commonFieldConstraint,
    LESS_THAN: "LESS_THAN",
    GREATER_THAN: "GREATER_THAN",
    // BETWEEN: "BETWEEN",
  },
  DATE_TIME_PICKER: {
    ...commonFieldConstraint,
    LESS_THAN: "LESS_THAN",
    GREATER_THAN: "GREATER_THAN",
    // BETWEEN: "BETWEEN",
  },
  NUMBER_INPUT: {
    ...commonFieldConstraint,
    IS: "Is",
    IS_NOT: "Is Not",
    LESS_THAN: "LESS_THAN",
    GREATER_THAN: "GREATER_THAN",
    LESS_THAN_OR_EQUALS_TO: "LESS_THAN_OR_EQUALS_TO",
    GREATER_THAN_OR_EQUALS_TO: "GREATER_THAN_OR_EQUALS_TO",
    BETWEEN: "BETWEEN",
  },
  TIME_PICKER: {
    ...commonFieldConstraint,
    LESS_THAN: "LESS_THAN",
    GREATER_THAN: "GREATER_THAN",
    // BETWEEN: "BETWEEN",
  },
  DROPDOWN: {
    ...commonFieldConstraint,
    STARTS_WITH: "STARTS_WITH",
    ENDS_WITH: "ENDS_WITH",
    // Other Choice Is Not Empty
    // Is Any Of
    // Is None Of
  },
  MULTIPLE_CHOICES: {
    ...commonFieldConstraint,
    CONTAINS: "CONTAINS",
    NOT_CONTAINS: "NOT_CONTAINS",
    //   Contains Any Of
    // Contains All Of
    // Contains None Of
  },
  LINEAR_SCALING: {
    IS: "Is",
    IS_NOT: "Is Not",
    LESS_THAN: "LESS_THAN",
    GREATER_THAN: "GREATER_THAN",
    LESS_THAN_OR_EQUALS_TO: "LESS_THAN_OR_EQUALS_TO",
    GREATER_THAN_OR_EQUALS_TO: "GREATER_THAN_OR_EQUALS_TO",
    // BETWEEN: "BETWEEN",
  },
  PAYMENT: {
    IS: "Is",
    IS_NOT: "Is Not",
    LESS_THAN: "LESS_THAN",
    GREATER_THAN: "GREATER_THAN",
    LESS_THAN_OR_EQUALS_TO: "LESS_THAN_OR_EQUALS_TO",
    GREATER_THAN_OR_EQUALS_TO: "GREATER_THAN_OR_EQUALS_TO",
    // BETWEEN: "BETWEEN",
  },
  CALCULATIVE: {
    IS: "Is",
    IS_NOT: "Is Not",
    LESS_THAN: "LESS_THAN",
    GREATER_THAN: "GREATER_THAN",
    LESS_THAN_OR_EQUALS_TO: "LESS_THAN_OR_EQUALS_TO",
    GREATER_THAN_OR_EQUALS_TO: "GREATER_THAN_OR_EQUALS_TO",
  },
  CHECK_BOX: {
    IS: "Is",
    IS_NOT: "Is Not",
  },
  YEAR_SELECTOR: {
    IS: "Is",
    IS_NOT: "Is Not",
  },
};

export const getFieldTitle = (
  fieldsMap: IFieldsMap,
  fieldId: string
): string => {
  const fieldsData = fieldsMap[fieldId] || { name: "" };

  return fieldsData.name ?? "";
};

export const validateFieldRule = (
  ruleDetails: IFieldLevelRuleClient,
  fieldConditionMap: IFieldLevelRuleConditionMap
): boolean => {
  let isRuleDetailsCompleted = true;
  const fieldConditionIds = ruleDetails?.fieldConditionIds || [];
  const fieldActions: any = ruleDetails?.action || {};
  interface IRequiredSubData {
    key: string;
    subdata: (string | IRequiredSubData)[];
  }

  const removeEmptyData = (data: any) => {
    const updatedData: any = {};
    Object.keys(data).forEach(function (key: string) {
      if (data[key] && typeof data[key] === "object") {
        updatedData[key] = removeEmptyData(data[key]);
      } else if (data[key] != "") {
        updatedData[key] = data[key];
      }
    });
    return updatedData;
  };
  const requiredfieldRuleData = [
    "ruleName",
    "logicalOperator",
    "fieldConditionIds",
  ];

  const updatedProfileData = removeEmptyData(ruleDetails);

  const validateFieldRuleData = (
    requiredfieldRuleData: (string | IRequiredSubData)[],
    updatedProfileData: { [x: string]: any[] }
  ) => {
    const filteredData: (string | IRequiredSubData)[] =
      requiredfieldRuleData?.filter((data: string | IRequiredSubData) => {
        if (typeof data == "string" && updatedProfileData[data]) return false;
        if (typeof data !== "string") {
          const { key, subdata } = data;
          if (updatedProfileData[key]) {
            Object.keys(updatedProfileData[key]).forEach(function (
              value: string,
              index: number
            ) {
              validateFieldRuleData(
                subdata,
                updatedProfileData[data.key][index]
              );
            });
            return false;
          }
        }
        return true;
      });

    if (filteredData.length > 0) {
      isRuleDetailsCompleted = false;
    }
  };

  const validateFieldConditions = (conditionIds: string[]) => {
    for (const index in conditionIds) {
      const conditionId = conditionIds[index];
      const fieldConditionData = { ...(fieldConditionMap[conditionId] ?? {}) };
      const { logicalOperator, fieldConditionIds = [] } = fieldConditionData;
      const updatedConditionData = removeEmptyData(fieldConditionData);
      const operator = fieldConditionData?.operator;
      const requiredFieldDataForCondition = [
        "operator",
        "fieldType",
        "fieldLocalId",
      ];
      if (operator && constraintWithRequiredValue.includes(operator)) {
        requiredFieldDataForCondition.push("value");
      }
      const requiredFieldDataForSubRule = [
        "logicalOperator",
        "fieldConditionIds",
      ];

      if (logicalOperator) {
        validateFieldRuleData(
          requiredFieldDataForSubRule,
          updatedConditionData
        );
      } else {
        validateFieldRuleData(
          requiredFieldDataForCondition,
          updatedConditionData
        );
      }
      validateFieldConditions(fieldConditionIds);
    }
  };
  const validateFieldActions = (fieldActions: IFieldLevelRuleActionServer) => {
    const { show, hide } = fieldActions;
    if (show?.length == 0 && hide?.length == 0) {
      isRuleDetailsCompleted = false;
    }
  };
  validateFieldRuleData(requiredfieldRuleData, updatedProfileData);
  validateFieldConditions(fieldConditionIds);
  validateFieldActions(fieldActions);
  return isRuleDetailsCompleted;
};

export const validatePageRule = (
  ruleDetails: IPageLevelRuleClient,
  pageConditionMap: IPageLevelRuleConditionMap
): boolean => {
  let isRuleDetailsCompleted = true;
  const pageConditionIds = ruleDetails?.pageConditionIds || [];
  const fieldActions: any = ruleDetails?.action;
  interface IRequiredSubData {
    key: string;
    subdata: (string | IRequiredSubData)[];
  }

  const removeEmptyData = (data: any) => {
    const updatedData: any = {};
    Object.keys(data).forEach(function (key: string) {
      if (data[key] && typeof data[key] === "object") {
        updatedData[key] = removeEmptyData(data[key]);
      } else if (data[key] != "") {
        updatedData[key] = data[key];
      }
    });
    return updatedData;
  };
  const requiredfieldRuleData = [
    "ruleName",
    "logicalOperator",
    "pageConditionIds",
  ];

  const updatedProfileData = removeEmptyData(ruleDetails);

  const validatePageRuleData = (
    requiredfieldRuleData: (string | IRequiredSubData)[],
    updatedProfileData: any
  ) => {
    const filteredData: (string | IRequiredSubData)[] =
      requiredfieldRuleData?.filter((data: string | IRequiredSubData) => {
        if (typeof data == "string" && updatedProfileData[data]) return false;
        if (typeof data !== "string") {
          const { key, subdata } = data;
          if (updatedProfileData[key]) {
            Object.keys(updatedProfileData[key]).forEach(function (
              value: string,
              index: number
            ) {
              validatePageRuleData(
                subdata,
                updatedProfileData[data.key][index]
              );
            });
            return false;
          }
        }
        return true;
      });

    if (filteredData.length > 0) {
      isRuleDetailsCompleted = false;
    }
  };

  const validatePageConditions = (conditionIds: string[]) => {
    for (const index in conditionIds) {
      const conditionId = conditionIds[index];
      const fieldConditionData = { ...(pageConditionMap[conditionId] ?? {}) };
      const { logicalOperator } = fieldConditionData;
      const updatedConditionData = removeEmptyData(fieldConditionData);
      const operator = fieldConditionData?.operator;
      const requiredFieldDataForCondition = [
        "operator",
        "fieldType",
        "fieldLocalId",
        "subFormLocalId",
      ];
      if (operator && constraintWithRequiredValue.includes(operator)) {
        requiredFieldDataForCondition.push("value");
      }
      const requiredFieldDataForSubRule = [
        "logicalOperator",
        "pageConditionIds",
      ];

      if (logicalOperator) {
        validatePageRuleData(requiredFieldDataForSubRule, updatedConditionData);
      } else {
        validatePageRuleData(
          requiredFieldDataForCondition,
          updatedConditionData
        );
      }
      // validatePageConditions(pageConditionIds);
    }
  };
  const validatePageActions = (fieldActions: any) => {
    const show = fieldActions?.show || [];
    const hide = fieldActions?.hide || [];
    const skip = fieldActions?.skip || [];
    const elseSkip = fieldActions?.elseSkip || [];
    if (
      show?.length == 0 &&
      hide?.length == 0 &&
      skip?.length == 0 &&
      elseSkip?.lenght == 0
    ) {
      isRuleDetailsCompleted = false;
    }
  };
  validatePageRuleData(requiredfieldRuleData, updatedProfileData);
  validatePageConditions(pageConditionIds);
  validatePageActions(fieldActions);
  return isRuleDetailsCompleted;
};

export enum numberRulesConstraint {
  IS = "IS",
  IS_NOT = "IS_NOT",
  IS_EMPTY = "IS_EMPTY",
  IS_NOT_EMPTY = "IS_NOT_EMPTY",
  LESS_THAN = "LESS_THAN",
  GREATER_THAN = "GREATER_THAN",
  LESS_THAN_OR_EQUALS_TO = "LESS_THAN_OR_EQUALS_TO",
  GREATER_THAN_OR_EQUALS_TO = "GREATER_THAN_OR_EQUALS_TO",
  // BETWEEN = "BETWEEN",
  MAXIMUM_DIGIT_LENGTH = "MAXIMUM_DIGIT_LENGTH",
}
export enum numberRulesConstraintNames {
  IS = "Is",
  IS_NOT = "Is Not",
  IS_EMPTY = "Is Empty",
  IS_NOT_EMPTY = "Is Not Empty",
  LESS_THAN = "Less Than",
  GREATER_THAN = "Greater Than",
  LESS_THAN_OR_EQUALS_TO = "Less Than or Equal To",
  GREATER_THAN_OR_EQUALS_TO = "Greater Than or Equal To",
  // BETWEEN = "Between",
  MAXIMUM_DIGIT_LENGTH = "Maximum Digit Length",
}

export enum textRulesConstraint {
  IS = "IS",
  IS_NOT = "IS_NOT",
  IS_EMPTY = "IS_EMPTY",
  IS_NOT_EMPTY = "IS_NOT_EMPTY",
  CONTAINS = "CONTAINS",
  NOT_CONTAINS = "NOT_CONTAINS",
  STARTS_WITH = "STARTS_WITH",
  ENDS_WITH = "ENDS_WITH",
  MAXIMUM_TEXT_LENGTH = "MAXIMUM_TEXT_LENGTH",
}

export enum textRulesConstraintNames {
  IS = "Is",
  IS_NOT = "Is Not",
  IS_EMPTY = "Is Empty",
  IS_NOT_EMPTY = "Is Not Empty",
  CONTAINS = "Contains",
  NOT_CONTAINS = "Not Contains",
  STARTS_WITH = "Starts With",
  ENDS_WITH = "Ends With",
  MAXIMUM_TEXT_LENGTH = "Maximum Text Length",
}
export enum allConstraint {
  IS = "IS",
  IS_NOT = "IS_NOT",
  IS_EMPTY = "IS_EMPTY",
  IS_NOT_EMPTY = "IS_NOT_EMPTY",
  LESS_THAN = "LESS_THAN",
  GREATER_THAN = "GREATER_THAN",
  LESS_THAN_OR_EQUALS_TO = "LESS_THAN_OR_EQUALS_TO",
  GREATER_THAN_OR_EQUALS_TO = "GREATER_THAN_OR_EQUALS_TO",
  MAXIMUM_DIGIT_LENGTH = "MAXIMUM_DIGIT_LENGTH",
  CONTAINS = "CONTAINS",
  NOT_CONTAINS = "NOT_CONTAINS",
  STARTS_WITH = "STARTS_WITH",
  ENDS_WITH = "ENDS_WITH",
  MAXIMUM_TEXT_LENGTH = "MAXIMUM_TEXT_LENGTH",
}
export enum allConstraintNames {
  IS = "Is",
  IS_NOT = "Is Not",
  IS_EMPTY = "Is Empty",
  IS_NOT_EMPTY = "Is Not Empty",
  LESS_THAN = "Less Than",
  GREATER_THAN = "Greater Than",
  LESS_THAN_OR_EQUALS_TO = "Less Than or Equal To",
  GREATER_THAN_OR_EQUALS_TO = "Greater Than or Equal To",
  MAXIMUM_DIGIT_LENGTH = "Maximum Digit Length",
  CONTAINS = "Contains",
  NOT_CONTAINS = "Not Contains",
  STARTS_WITH = "Starts With",
  ENDS_WITH = "Ends With",
  MAXIMUM_TEXT_LENGTH = "Maximum Text Length",
}
export const allConstraintNamesItem: any = {
  IS: "Is",
  IS_NOT: "Is Not",
  IS_EMPTY: "Is Empty",
  IS_NOT_EMPTY: "Is Not Empty",
  LESS_THAN: "Less Than",
  GREATER_THAN: "Greater Than",
  LESS_THAN_OR_EQUALS_TO: "Less Than or Equal To",
  GREATER_THAN_OR_EQUALS_TO: "Greater Than or Equal To",
  MAXIMUM_DIGIT_LENGTH: "Maximum Digit Length",
  CONTAINS: "Contains",
  NOT_CONTAINS: "Not Contains",
  STARTS_WITH: "Starts With",
  ENDS_WITH: "Ends With",
  MAXIMUM_TEXT_LENGTH: "Maximum Text Length",
};

export const emptyGroupedRule = {
  logicalOperator: "or",
  conditions: [
    {
      operator: "",
      value: "",
      fieldType: "",
      fieldLocalId: "",
    },
  ],
};

export const logicSwitchOptions = [
  {
    label: "AND",
    value: "and",
  },
  {
    label: " OR ",
    value: "or",
  },
];

export enum logicalSwitchOption {
  AND = "and",
  OR = "or",
}

export const validateFieldRuleValue = (
  ruleValue: string,
  submissionValue: any,
  ruleType: string
): boolean => {
  switch (ruleType) {
    case textRulesConstraint.IS:
      if (!checkIfIsConditionSatisfied(submissionValue, ruleValue)) {
        return false;
      }
      break;
    case textRulesConstraint.IS_NOT:
      if (!checkIfIsConditionSatisfied(submissionValue, ruleValue)) {
        return false;
      }
      break;
    case textRulesConstraint.IS_EMPTY:
      if (typeof ruleValue === "string" && submissionValue?.length > 0)
        return false;
      break;

    case textRulesConstraint.IS_NOT_EMPTY:
      if (typeof ruleValue === "string" && submissionValue?.length == 0)
        return false;
      break;

    case textRulesConstraint.CONTAINS:
      if (
        typeof ruleValue === "string" &&
        !submissionValue?.includes(ruleValue)
      )
        return false;
      break;
    case textRulesConstraint.NOT_CONTAINS:
      if (ruleValue && typeof ruleValue === "string") {
        const regEx = new RegExp(ruleValue);
        if (regEx.test(submissionValue)) {
          return false;
        }
      }
    case textRulesConstraint.STARTS_WITH:
      if (ruleValue) {
        const prefix = ruleValue;
        if (!submissionValue.startsWith(prefix)) {
          return false;
        }
      }
      break;

    case textRulesConstraint.ENDS_WITH:
      if (ruleValue) {
        const prefix = ruleValue;
        if (!submissionValue.endsWith(prefix)) {
          return false;
        }
      }
      break;
    case textRulesConstraint.MAXIMUM_TEXT_LENGTH:
      if (
        typeof ruleValue === "string" &&
        submissionValue?.length > parseInt(ruleValue)
      )
        return false;
      break;

    // case numberRulesConstraint.BETWEEN: //two textinput is required for between value
    // if (
    //   (parseInt(submissionValue) < parseInt(ruleValue?.min) &&
    //     ruleValue?.isIncludeMin) ||
    //   (parseInt(submissionValue) > parseInt(ruleValue?.max) &&
    //     ruleValue?.isIncludeMax)
    // )
    //   return false
    // break;
    case numberRulesConstraint.GREATER_THAN:
      if (
        typeof ruleValue === "string" &&
        parseInt(submissionValue) <= parseInt(ruleValue)
      )
        return false;
      break;
    case numberRulesConstraint.GREATER_THAN_OR_EQUALS_TO:
      if (
        typeof ruleValue === "string" &&
        parseInt(submissionValue) < parseInt(ruleValue)
      )
        return false;
      break;

    case numberRulesConstraint.LESS_THAN:
      if (
        typeof ruleValue === "string" &&
        parseInt(submissionValue) >= parseInt(ruleValue)
      )
        return false;
      break;

    case numberRulesConstraint.LESS_THAN_OR_EQUALS_TO:
      if (
        typeof ruleValue === "string" &&
        parseInt(submissionValue) > parseInt(ruleValue)
      )
        return false;
      break;

    case numberRulesConstraint.MAXIMUM_DIGIT_LENGTH:
      if (
        typeof ruleValue === "string" &&
        submissionValue?.length > parseInt(ruleValue)
      )
        return false;
      break;

    default:
      break;
  }

  return true;
};

export const validateNumberRuleOnly = (
  //not used
  ruleValue: numberRulesConstraint,
  submissionValue: any,
  ruleType: string
): boolean => {
  switch (ruleType) {
    case numberRulesConstraint.IS:
      if (ruleValue !== submissionValue) {
        return false;
      }
      break;
    case numberRulesConstraint.IS_NOT:
      if (ruleValue == submissionValue) {
        return false;
      }
      break;
    case numberRulesConstraint.IS_EMPTY:
      if (typeof ruleValue === "string" && submissionValue?.length > 0)
        return false;
      break;

    case numberRulesConstraint.IS_NOT_EMPTY:
      if (typeof ruleValue === "string" && submissionValue?.length == 0)
        return false;
      break;
    // case numberRulesConstraint.BETWEEN: //two textinput is required for between value
    // if (
    //   (parseInt(submissionValue) < parseInt(ruleValue?.min) &&
    //     ruleValue?.isIncludeMin) ||
    //   (parseInt(submissionValue) > parseInt(ruleValue?.max) &&
    //     ruleValue?.isIncludeMax)
    // )
    //   return false
    // break;
    case numberRulesConstraint.GREATER_THAN:
      if (
        typeof ruleValue === "string" &&
        parseInt(submissionValue) <= parseInt(ruleValue)
      )
        return false;
      break;
    case numberRulesConstraint.GREATER_THAN_OR_EQUALS_TO:
      if (
        typeof ruleValue === "string" &&
        parseInt(submissionValue) < parseInt(ruleValue)
      )
        return false;
      break;

    case numberRulesConstraint.LESS_THAN:
      if (
        typeof ruleValue === "string" &&
        parseInt(submissionValue) >= parseInt(ruleValue)
      )
        return false;
      break;

    case numberRulesConstraint.LESS_THAN_OR_EQUALS_TO:
      if (
        typeof ruleValue === "string" &&
        parseInt(submissionValue) > parseInt(ruleValue)
      )
        return false;
      break;

    case numberRulesConstraint.MAXIMUM_DIGIT_LENGTH:
      if (
        typeof ruleValue === "string" &&
        submissionValue?.length > parseInt(ruleValue)
      )
        return false;
      break;

    default:
      break;
  }

  return true;
};

export const checkIfIsConditionSatisfied = (
  submissionValue: any,
  ruleValue: string
): boolean => {
  return (
    (typeof submissionValue === "string" &&
      ruleValue.toUpperCase() == submissionValue.toUpperCase()) ||
    ruleValue?.toUpperCase() == submissionValue?.optionValue?.toUpperCase()
  );
};

export const checkIfIsNotConditionSatisfied = (
  submissionValue: any,
  ruleValue: string
): boolean => {
  return (
    (typeof submissionValue === "string" &&
      ruleValue.toUpperCase() === submissionValue.toUpperCase()) ||
    (submissionValue?.optionValue && ruleValue === submissionValue?.optionValue)
  );
};

export const getFilteredFieldsnameAndIdSelectorOfSubform = (
  fieldsMap: IFieldsMap,
  fieldIdsIgnore: string[],
  fieldTypesToIgnore: string[],
  formId: string
): IOption[] => {
  const filteredFieldOptions: any[] = [];
  Object.keys(fieldsMap).map((key: string) => {
    const fieldData: FieldProps = fieldsMap[key];
    const {
      title = "",
      localId,
      isSection,
      fieldType = "",
      parentFormId,
      name = "",
    } = fieldData;

    const checkIsSection =
      isSection || fieldType == FormFieldTypes?.SECTION || false;
    if (
      !fieldIdsIgnore.includes(key) &&
      !checkIsSection &&
      !fieldTypesToIgnore.includes(fieldType) &&
      parentFormId == formId
    ) {
      filteredFieldOptions.push({
        content: name || title || "Untitled field",
        value: key,
        fieldType,
        parentFormId,
        localId,
        title: name || title || "Untitled field",
        // subtitle: fieldType || "",//can be used for better UX
      });
    }
  });
  return filteredFieldOptions;
};

export const fieldLevelRuleInitialValueServerFormat: IFieldLevelRuleServer = {
  ruleName: "Untitled Field Rule",
  logicalOperator: "or",
  conditions: [
    {
      operator: "",
      value: "",
      fieldType: "",
      fieldLocalId: "",
    },
    // {
    //   operator: "",
    //   value: "",
    //   fieldType: "",
    //   fieldLocalId: "",
    // },
  ],
  action: {
    show: [],
    hide: [],
  },
};

export const getFieldSelectOptionForAction = (
  fieldsMap: IFieldsMap,
  fieldIdsIgnore: string[],
  fieldTypesToIgnore: string[]
): any[] => {
  const filteredFieldOptions: any = [];
  Object.keys(fieldsMap).map((key: string) => {
    const fieldData: FieldProps = fieldsMap[key];
    const {
      title = "",
      localId,
      isSection,
      fieldType = "",
      parentFormId,
      name = "",
    } = fieldData;

    const checkIsSection =
      isSection || fieldType == FormFieldTypes?.SECTION || false;
    if (
      !fieldIdsIgnore.includes(key) &&
      !checkIsSection &&
      !fieldTypesToIgnore.includes(fieldType)
    ) {
      filteredFieldOptions.push({
        content: name || title || "Untitled field",
        value: key,
        fieldType,
        parentFormId,
        localId,
        title: name || title || "Untitled field",
        // subtitle: fieldType || "",//can be used for better UX
      });
    }
  });
  return filteredFieldOptions;
};
export const getStringValue = (value: any) => {
  let val = "";
  // if (value && Array.isArray(value)) {
  //     val = value
  //   } else
  if (typeof value == "object") {
    val = value?.optionValue || value;
  } else if (value && typeof value == "string") {
    val = value;
  }
  return val;
};
export const getUserAttributesKey = (attributes: IAttribute): IOption[] => {
  const keys = Object.keys(attributes ?? {});
  let options: IOption[] = [];
  for (const key of keys) {
    options.push({
      value: cleanOrgKey(key),
      content: cleanOrgKey(key),
    });
  }
  options.push({
    value: "orgId",
    content: "Org Id",
  });
  return options;
};
export const getUserAttributes = (attributes: IAttribute): IOption => {
  const userAttributeOptions = getUserAttributesKey(attributes);
  const userAttribute: IOption = {
    value: "user_attributes",
    content: "User Attributes",
    options: userAttributeOptions,
  };
  return userAttribute;
};
